import { z } from 'zod';
import type { components } from '@sentinel/api-client';

/**
 * The user_code is presented to humans in `XXXX-XXXX` form (RFC 8628 §6.1).
 * We accept dashes and lowercase, then normalize before sending.
 */
export const userCodeSchema = z.object({
  user_code: z
    .string()
    .min(1)
    .transform((v) => v.replace(/[^A-Za-z0-9]/g, '').toUpperCase())
    .refine((v) => v.length >= 6 && v.length <= 16, { message: 'invalid_code' }),
});

export type UserCodeInput = z.infer<typeof userCodeSchema>;

export type VerifyResponse = components['schemas']['DeviceVerifyResponse'];

/** The `consent_required` arm of the untagged device-verify response. */
export type VerifyConsentRequired = Extract<VerifyResponse, { consent_required: boolean }>;

export function isConsentRequired(r: VerifyResponse): r is VerifyConsentRequired {
  return 'consent_required' in r && r.consent_required === true;
}
